<template>
    <div class="container mar-bt2">
        <div class="row mar-tp1 mar-bt2 align-items-center">
            <i class="fa fa-bandcamp fa-lg mar-r1 text-info"></i>
            <h6>当前位置&nbsp;>&nbsp;<router-link to="/home">首页</router-link>&nbsp;>&nbsp;<router-link to="/product">产品与服务</router-link>&nbsp;>&nbsp;产品详情</h6>
        </div>
        <div class="row">
            <div class="col-6 border padd-3 text-left">
                <div>
                    <h5>{{filterproinfo[0].name}}</h5>
                    <p class="font-4">{{filterproinfo[0].intro}}</p>
                </div>
                
                <div><p class="font-3">产品特色</p>
                    <div class="row" v-for="(item,index) in filterproinfo[0].features" :key="index">
                        <div class="col-2"><img class="img-suit" src="@/assets/images/feature.png"></div>
                        <div class="col-10">
                            <p style="font-weight:bold;">{{item.title}}</p>
                            <p class="font-2">{{item.cont}}</p>
                        </div>                        
                    </div>
                </div>
                <div><p class="font-3">主要功能</p>
                    <div class="row">
                        <div class="col-3" v-for="(item,index) in filterproinfo[0].profunc" :key="index">
                            <span class="sp-1">0{{index+1}}</span>{{item}}
                        </div>                       
                    </div>
                </div>
            </div>
            <div class="col-6"><img class="img-suit" :src="require('@/assets/images/'+filterproinfo[0].pic)"></div>            
        </div>
    </div>
</template>
<script>
 
export default {
   data(){
       return{
           proinfos:[
               {id:1,pic:'pro1.png',name:'在线教育云平台',intro:'易梵教育云平台是专业的SaaS平台，为教育企业提供直播、录播、题库、问答社区、在线支付等在线教育所必须的功能。',features:[
                   {title:'专业性',cont:'易梵教育云平台的创始人和开发核心都从事教育行业多年，对在线教育比较了解，更熟悉互联网技术。用户只需注册一个账号，其他的专业维护都由我们帮您做好。'},
                   {title:'跨平台',cont:'易梵教育云平台是一个跨平台的系统，可以运行在电脑端，也可以在PAD、手机等移动端，满足各个不同类型学员的需求。'},
                   {title:'灵活化',cont:'易梵教育云平台功能强大，非常灵活，可以自行组合所需功能，课程设置也更加灵活，既可以设置成直播，也可以设置成录播。'},
               ],profunc:['网校管理','课程管理','教务教学','学员管理','营销管理','订单管理']},
               {id:2,pic:'pro2.png',name:'企业管理信息系统',intro:'企业管理信息系统是一套解决企业综合信息的系统，可以帮助企业实现从人事到业务再到财务的全方位管理，支持为不同企业量身定制。',features:[
                   {title:'系统化',cont:'系统每个模块均存在内在的联系，数据实现内部共享，完整的数据链，一个系统即可实现企业全部业务需求，满足企业信息化需求。'},
                   {title:'灵活性',cont:'不同的用户分配不同的角色，享有不同的操作权限，功能模块能自由调整，非常灵活。'},
                   {title:'安全性',cont:'数据库采用SQLSERVER等大型数据库，开发平台使用.NET CORE平台，实现前后端分离设计，保证系统的安全可靠。'},
               ],profunc:['人事管理','项目管理','采购管理','财务管理','物流管理','系统设置']},
               {id:3,pic:'pro3.png',name:'企事业网站定制',intro:'易梵科技为企事业单位客户提供网站定制服务，针对不同行业客户的差异化需求，为客户提供定制化的网站建设解决方案。',features:[
                   {title:'定制化',cont:'根据客户需求量身定制，可定制的需求功能开发，以用户体验为导向的设计。'},                  
               ],profunc:['响应式H5网站','企业形象网站','政府部门网站','学校、教育机构网站']},
               {id:4,pic:'pro4.png',name:'公众号、小程序开发',intro:'微信公众号、小程序定制开发，个性设计，帮助企业提高微信营销，完美展现企业及品牌形象，实现低成本、短周期开发手机应用功能。',features:[
                   {title:'易推广',cont:'利用微信巨大的用户流，植入微信端，更容易积累粉丝，利于企业推广。'},
                   {title:'跨平台',cont:'完美兼容Android和IOS两大主流操作系统，无需多次开发，节省开发成本。'},
                   {title:'易使用',cont:'相对于手机APP，公众号、小程序无需用户下载安装即可使用，用户体验更舒适，使用更方便。'},
               ],profunc:['订阅号开发','服务号开发','企业微信','小程序开发']},
               {id:5,pic:'pro5.png',name:'企业进销存管理系统',intro:'企业进销存管理系统为批发零售企业提供全程信息化管理服务，该系统界面设计简约大方，功能强大，从根本上解决了各个系统间数据不兼容的问题，各功能模块间相互关联，数据实时汇总，可根据企业需求定制开发功能。',features:[
                   {title:'一体化',cont:'从产品进货到完成销售的整个过程实现全信息化管理，仓库、销售、采购的一体化管理模式，解决销售企业数据不统一的问题。'},
                   {title:'智能化',cont:'智能销售跟踪，自动跟踪商品销售整个过程，避免遗漏操作；智能库存管理，低库存、库存积压等都有自动报警功能；智能查询，可按关键字模糊查询，编码查询，拼音查询等。'},
                   {title:'安全性',cont:'系统对不同角色分配不同的操作权限，角色的操作权限有详细的管理，保证系统安全可靠。'},
               ],profunc:['货品管理','采购管理','销售管理','库存管理','经营统计','系统设置']},
               {id:6,pic:'pro6.png',name:'建筑劳务企业管理系统',intro:'易梵建筑劳务管理系统是由杭州易梵科技有限公司自主研发的一套面向建筑劳务企业的专业劳务管理软件。系统基于B/S架构设计开发，界面交互丰富，操作便捷，可根据企业需求定制功能模块。',features:[
                   {title:'便捷性',cont:'系统针对建筑劳务派遣的特点，融合现代化技术，对系统各功能模块进行优化，使企业能方便快捷的使用本系统，大大降低工作量。'},
                   {title:'定制性',cont:'系统可根据各建筑劳务企业的实际需求，在系统原有功能的基础上，对功能模块进行增减定制，满足企业实际需求。'},
                   {title:'安全性',cont:'系统对不同角色分配不同的操作权限，角色的操作权限有详细的管理，保证系统安全可靠。'},
               ],profunc:['人员管理','客户管理','合同管理','财务管理','系统设置']},
               {id:7,pic:'pro7.png',name:'广告企业管理系统',intro:'系统基于目前国内成熟的广告业务管理模式，以客户管理为基础，整合企业各项资源，贯穿从开单到交付的整个业务流程，为广告企业提供智能化管理平台。',features:[
                   {title:'灵活定制',cont:'根据不同客户需求，系统能非常灵活的定制开发新的功能，以满足客户需求。'},
                   {title:'系统安全',cont:'系统对不同角色分配不同的操作权限，角色的操作权限有详细的管理，保证系统安全可靠。'},
                   {title:'跨区域管理',cont:'系统支持跨区域、跨部门的管理和数据共享，使身处不同区域的人员都能同时查看最新数据和业务进展，提高工作效率和业务管理水平。'},
               ],profunc:['业务管理','财务管理','统计报表','客户管理','材料管理','系统设置']},
               {id:8,pic:'pro8.png',name:'手机APP开发',intro:'易梵科技为各企事业单位和个人提供手机APP开发定制服务，满足移动端操作和办公的需要，实现随时随地移动互联的需求。',features:[
                   {title:'移动性',cont:'充分利用移动互联网特点，实现在移动终端操作各项需求，满足随时随地办公的需要。'},
                   {title:'定制性',cont:'根据不同客户需求，量身定制APP应用，可支持Android/IOS双操作系统,支持企业端/客户端双端开发。'},
                   {title:'专业性',cont:'专业开发团队设计开发，产品设计电商、医疗、教育、家政、地产等多个行业领域。'},
               ],profunc:['电商类APP','教育类APP','医疗类APP','家政类APP','地产类APP','其他类APP']},
           ]
       }
   } ,
   
   computed:{
       filterproinfo:function(){
          var id=this.$route.params.id; 
          return this.proinfos.filter(function(item){
            return item.id==id;
          });
       }
   }
}
</script>